import { useMsal } from "@azure/msal-react";
import { InteractionStatus } from "@azure/msal-browser";
import * as constants from "../utils/constants.ts";
import { ENVIRONMENTS, getValueByEnv } from "../utils/runtimeEnv";
const useSignOut = () => {
  const { instance, inProgress } = useMsal();

  const handleSignOut = () => {
    if (inProgress !== InteractionStatus.None) {
      return;
    }

    const getbaseurl = () => {
      return getValueByEnv({
        [ENVIRONMENTS.LOCAL]: constants.BASE_LOCALHOST_URL,
        [ENVIRONMENTS.DEV]: constants.BASE_DEV_URL,
        [ENVIRONMENTS.TEST]: constants.BASE_TEST_URL,
        [ENVIRONMENTS.PROD]: constants.BASE_PROD_URL,
      });
    };
    instance
      .logoutRedirect({
        postLogoutRedirectUri: getbaseurl(),
      })
      .catch((e) => {
        console.error(e);
      });
  };

  return handleSignOut;
};

export default useSignOut;